var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("We're not quite ready!")]),_c('div',{staticClass:"main"},[_c('SignupComp')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }